import { render, staticRenderFns } from "./StandardReportAdminSidebar.vue?vue&type=template&id=1b7fb6e4&scoped=true"
import script from "./StandardReportAdminSidebar.vue?vue&type=script&lang=js"
export * from "./StandardReportAdminSidebar.vue?vue&type=script&lang=js"
import style0 from "./StandardReportAdminSidebar.vue?vue&type=style&index=0&id=1b7fb6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7fb6e4",
  null
  
)

export default component.exports